<template>
  <b-modal ref="modal" v-bind="$attrs" :id="id" :title="modalTitle" @ok="handleOk" title-class="font-18" lazy>
    <component
      :is="form"
      v-bind="formProps"
      v-on="formListeners"
      v-model="model"
      :is-valid.sync="isValid"
      :errors="errors"
      ref="form"
      is-modal="true"
    >
    </component>
    <template #modal-footer="{ ok, cancel}">
      <b-button size="md" variant="link-primary" @click="cancel()">
        Batal
      </b-button>
      <b-button size="md" variant="primary" @click="ok()" :disabled="loading || updating">
        <i v-if="updating" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import ModalEdit from "./modal-edit";
import Form from "@/router/views/projections/cash_on_hand/form";

export default {
  extends: ModalEdit,
  props: {
    modalTitle: {
      default() {
        return this.lodash.startCase("cash on hand");
      }
    },
    form: {
      type: Object,
      default: function() {
        return Form;
      }
    },
    value: {
      type: Object,
      default: function() {
        return {};
      }
    },
    hideHeader: {
      type: Boolean,
      default: true
    },
    modelKey: {
      type: String,
      default: "key"
    }
  },
  data() {
    return {
      loading: false,
      isValid: true,
      model: {
        // value: 0,
        ...this.value
      }
    };
  },
  // mounted() {
  //   this.model = {
  //     value: 0,
  //     ...this.value
  //   };
  // },
  watch: {
    value(value) {
      this.model = {
        ...value
      };
    }
  },
  methods: {
    update(value) {
      return this.$axios.put(`/constants/cash_on_hand`, value);
    },
    updateSuccessAlert() {
      return Swal.fire({
        title: this.$t("Success") + "!",
        text: this.$t(`You've updated {something}`, { something: "Cash on Hand" }),
        type: "success",
        showConfirmButton: false,
        timer: 1500
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .modal-header,
  .modal-footer {
    border: 0;
  }
  .modal-body {
    padding-block: 0;
  }
}
</style>
